const BASE_URL = 'https://api.dev.auxo.dk';

/**
 * Henter produkter fra CMS v2 endpointet.
 * Understøtter server-side filtrering på kategori-taxonomien.
 */
export async function getProducts(categorySlug = null) {
  try {
    let url = `${BASE_URL}/public/v2/content/products?limit=100`;
    if (categorySlug) {
      url = `${BASE_URL}/public/v2/content/products?term=product-category:${categorySlug}&limit=100`;
    }
    const res = await fetch(url);
    if (!res.ok) throw new Error('Kunne ikke hente produkter');
    const data = await res.json();
    let items = data.items || [];

    // Robust fallback: Hvis server-side filtrering returnerer 0 resultater, men vi har en kategori,
    // henter vi alle produkter (op til 100) og filtrerer på klienten for at sikre visning.
    if (items.length === 0 && categorySlug) {
      const fallbackRes = await fetch(`${BASE_URL}/public/v2/content/products?limit=100`);
      if (fallbackRes.ok) {
        const fallbackData = await fallbackRes.json();
        const allItems = fallbackData.items || [];
        items = allItems.filter(item => {
          const itemTerms = item.terms?.['product-category'] || [];
          return itemTerms.includes(categorySlug);
        });
      }
    }

    return items;
  } catch (err) {
    console.error('Fejl ved hentning af produkter:', err);
    return [];
  }
}

/**
 * Henter alle forhandlere fra CMS.
 */
export async function getResellers() {
  try {
    const res = await fetch(`${BASE_URL}/public/content/resellers`);
    if (!res.ok) throw new Error('Kunne ikke hente forhandlere');
    return await res.json();
  } catch (err) {
    console.error('Fejl ved hentning af forhandlere:', err);
    return [];
  }
}

/**
 * Henter alle gallerier fra CMS.
 */
export async function getGalleries() {
  try {
    const res = await fetch(`${BASE_URL}/public/content/gallery`);
    if (!res.ok) throw new Error('Kunne ikke hente gallerier');
    return await res.json();
  } catch (err) {
    console.error('Fejl ved hentning af gallerier:', err);
    return [];
  }
}

/**
 * Henter et specifikt galleri via dets slug.
 */
export async function getGalleryBySlug(slug) {
  try {
    // Vi kan hente det direkte via by-slug endpointet for det danske sprog
    const res = await fetch(`${BASE_URL}/public/by-slug/da/${slug}`);
    if (!res.ok) {
      // Fallback: Hent alle gallerier og find den rigtige
      const galleries = await getGalleries();
      return galleries.find(g => g.slug?.da === slug || g.slug === slug);
    }
    return await res.json();
  } catch (err) {
    console.error(`Fejl ved hentning af galleri med slug ${slug}:`, err);
    // Fallback
    try {
      const galleries = await getGalleries();
      return galleries.find(g => g.slug?.da === slug || g.slug === slug);
    } catch {
      return null;
    }
  }
}
